/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountTransactionDto { 
    id?: number;
    accountActivityStatusId?: number;
    referenceJournalEntryId?: string | null;
    amount?: number;
    transactionType?: string | null;
    description?: string | null;
    credit?: number;
    debit?: number;
    accountId?: number;
    referenceNumber?: string | null;
    type?: string | null;
    tenantId?: number | null;
    transactionId?: string | null;
    transactiondate?: string | null;
    transactionMode?: string | null;
    receiptNumber?: string | null;
    chequeNumber?: string | null;
    comment?: string | null;
    generalLedger?: string | null;
    creationTime?: string;
    accountNumber?: string | null;
}

